import { Asset,NotFoundError } from "@stellar/stellar-sdk";
import BigNumber from "bignumber.js";
import { Account,Collection, CollectionParams, WatcherParams, WatcherResponse,AssetToken,Token} from "../../wallet-sdk/types";

import {makeDisplayAbleOperations } from './MakeDisplayableOperations'
import { DisplayableOperation } from "../../../../types/types";
import { Horizon } from "@stellar/stellar-sdk";

const horizonUrl = import.meta.env.VITE_HORIZON?import.meta.env.VITE_HORIZON:'https://horizon-testnet.stellar.org'

export let horizon = new Horizon.Server(horizonUrl)


export interface ClaimableBalance {
    
    id:string;
    isRecipient:boolean;
    other_account:Account;
    amount: BigNumber;
    asset:string;
    abs_before?:any;
    not_abs_before?:any;
    unconditional?:boolean|null;

}

interface CallbacksObject {
    accountDetails?: () => void;
    operations?: () => void;
}

  interface ErrorHandlersObject {
    accountDetails?: (error: any) => void;
    operations?: (error: any) => void;
  }


export async function getClaimableBalances(accountId:string):Promise<[any,Collection<ClaimableBalance>|null]>{

    try {

        const payments = await horizon.claimableBalances()
        .claimant(accountId)
        .limit(10) // limit to the first 10 tx only
        .order('desc')
        .call()
       
        const balances = await processClaimableBalances(accountId,payments);

        return [null,balances]
        
    } catch (error) {

        return [error,null]
        
    }
}

async function processClaimableBalances(accountId:string,payments: Horizon.ServerApi.CollectionPage<Horizon.ServerApi.ClaimableBalanceRecord>):Promise<Collection<ClaimableBalance>>{

    return {
        next: async () => {
            const res = await payments.next()
            return processClaimableBalances(accountId,res)
        },
        prev: async () =>{
            const res = await payments.prev()
            return processClaimableBalances(accountId,res)
        },
        records: await makeDisplayableClaimablePayments({ publicKey: accountId },payments.records),
    }

}

async function makeDisplayableClaimablePayments(subjectAccount: Account,payments: Array<Horizon.ServerApi.ClaimableBalanceRecord>): Promise<ClaimableBalance[]> {
    return Promise.all(
      payments.map(
          async (payment:Horizon.ServerApi.ClaimableBalanceRecord): Promise<ClaimableBalance> => {
              
            let abs_before = null;
            let not_abs_before = null;
            let unconditional_claim= null;
            let other_account = {publicKey:payment.sponsor?payment.sponsor:'Stellar Account'}
            
            const isRecipient= payment.sponsor !==subjectAccount.publicKey

            payment.claimants.map((claimant:Horizon.HorizonApi.Claimant)=>{
 
                if (claimant.destination === subjectAccount.publicKey){
                    
                    abs_before = claimant.predicate.abs_before;
                    not_abs_before = claimant.predicate.not?.abs_before;

                    if (!claimant.predicate.abs_before && !claimant.predicate.and && !claimant.predicate.not && !claimant.predicate.or && !claimant.predicate.rel_before){
                        unconditional_claim = true
                    }
                    
                }
            })

          return {
            id:payment.id,
            isRecipient,
            other_account,
            amount: new BigNumber(payment.amount),
            asset:payment.asset,
            abs_before:abs_before,
            not_abs_before:not_abs_before,
            unconditional:unconditional_claim
          };
        },
      ),
    );
}


export async function isClaimaBalance(claimableBalanceId:string):Promise<[any,boolean]>
{

    try {

        await horizon.claimableBalances()
        .claimableBalance(claimableBalanceId)
        .call()

        return [null,true]
        
    } catch (error) {

        if (error instanceof NotFoundError) {
            
            return [null,false]
        } 
        
        else return [error,false]; 
    }
    



}

export async function getNetworkFee(){
            
    const feeStats = await horizon.feeStats();
    const fee = '0'
    //feeStats.max_fee.p99;
    //feeStats.fee_charged.mode;
    //Math.min(parseInt(feeStats.fee_charged.mode, 10), 10000).toString(); // moderate fee, 10000 max
    return fee
}

export async function isFunded(stellarAccount:string):Promise<boolean> {

    try {

        const result = await horizon.loadAccount(stellarAccount);
        
        return true
        
    } catch (error) {

        return false
        
    }

}

    /**
     * Method to check for specific if a stellar account trust a specific asset
     * 
     * @param account: the stellar account that trust operation needs to be checked
     * @param assetCode : the stellar asset code (i.e. oEUR)
     * @param assetIssuer: the stellar account representing the issuer of the asset
     * @returns : boolean 
     */
export async function checkAssetTrust(account:string,assetCode:string,assetIssuer:string):Promise<[any,boolean|null]>{

    try {

        let assetTrusted = false;
        
        const accountDetails = await horizon.loadAccount(account);

        accountDetails.balances.forEach((balance:Horizon.HorizonApi.BalanceLine) => {

            const identifier = getBalanceIdentifier(balance);

            if (identifier!='native'){

                const assetAndIssuerOrPool = identifier.split(':');
                
                if(assetAndIssuerOrPool[1]!='lp'){

                    if (assetAndIssuerOrPool[0] ===assetCode && assetAndIssuerOrPool[1] ===assetIssuer){
                        assetTrusted =true
                    }
                }

            } 
        });

    return [null,assetTrusted]
        
    } catch (error) {
        return [error,null]
        
    }
    
}


export async function fetchOperations(account:string,params: CollectionParams = {}):Promise<Collection<DisplayableOperation>|any>{

    try {

        const operations = await horizon.operations()
        .forAccount(account)
        .limit(params.limit || 10)
        .order(params.order || "desc")
        .cursor(params.cursor || "now")
        .call()
        return _processOperations({publicKey:account},operations);

    } catch (error) {

        return error
    }
}

async function _processOperations(accountId:Account,operations:Horizon.ServerApi.CollectionPage<Horizon.ServerApi.OperationRecord>): Promise<Collection<DisplayableOperation>>{

    return {
        next: async () => {
            const res = await operations.next()
            return _processOperations(accountId,res)
        },
        prev: async () => {
            const res = await operations.prev()
            return _processOperations(accountId,res)
        },
        records: await makeDisplayAbleOperations(accountId,operations.records)
      };
}

export function watchOperations(accountId:string,params: WatcherParams<DisplayableOperation>){

    /*
    const { onMessage, onError } = params;
    let getNextPayments: () => Promise<Collection<DisplayableOperation>>;
    
    fetchOperations(accountId)
    .then((res) => {
        getNextPayments = res.prev
        res.records.forEach(onMessage);

        callbacks.operations = debounce(() => {
            getNextPayments()
              .then((nextRes) => {
                // afterwards, "next" will be the next person!
                getNextPayments = nextRes.next;
  
                // get new things
                if (nextRes.records.length) {
                  nextRes.records.forEach(onMessage);
                }
              })
              .catch(onError);
          }, 2000);
          errorHandlers.operations = onError;
  
    })

    .catch((err) => {

    onError(err);
    });
    */

}

/**
 * Get the string identifier for a balance line item from Horizon. The response
 * should be the same as if that balance was a Token object, and you passed it
 * through `getTokenIdentifier`
 * @returns Returns `${tokenCode}:${issuerKey}`.
 */
 export function getBalanceIdentifier(balance: Horizon.HorizonApi.BalanceLine): string {
    
    if ("asset_issuer" in balance && !balance.asset_issuer) {
      return "native";
    }

    switch (balance.asset_type) {
      case "credit_alphanum4":
      case "credit_alphanum12":
        return `${balance.asset_code}:${balance.asset_issuer}`;
  
      case "liquidity_pool_shares":
        return `${balance.liquidity_pool_id}:lp`;
  
      default:
        return "native";
    }
}

/**
 * Get the string identifier for a token.
 * @returns "native" if the token is native, otherwise returns
 * `${tokenCode}:${issuerKey}`.
 */
 function getTokenIdentifier(token: Token): string {
    if (token.type === "native") {
      return "native";
    }
  
    return `${token.code}:${(token as AssetToken).issuer.key}`;
  }

  /**
 * Convert a Wallet-SDK-formatted Token object to a Stellar SDK Asset object.
 * @returns Returns `${tokenCode}:${issuerKey}`.
 */
function getStellarSdkAsset(token: Token): Asset {
    if (token.type === "native") {
      return Asset.native();
    }
  
    return new Asset(token.code, (token as AssetToken).issuer.key);
  }





